class Courts {
  constructor() {
    const courtsModels = document.querySelector(".models")
    this.new_grass_selector(courtsModels)
  }

  new_grass_selector($selector) { 
    const courtsSelector = $selector.querySelectorAll(".models__selector > p")
    const courtsInfoCards = $selector.querySelectorAll(".models__info-card")
    const courtImage = $selector.querySelector(".models__image-display > img")
    const courtRegex = /(?<=\/images\/courts\/courts_)(.*)(?=.png)/

    // On click, display selected model
    courtsSelector.forEach((court) => {
      court.addEventListener("click", () => {
        clearSelector(courtsSelector, "selected")
        court.classList.add("selected")
        displaySelectedElementInfo(court, courtsInfoCards)
        courtImage.src = courtImage.src.replace(courtRegex, court.dataset.court)
      })
    })

    // Clear selection
    function clearSelector(selectorElements, selectClass) {
      selectorElements.forEach((element) => {
        if (element.classList.contains(selectClass)) {
          element.classList.remove(selectClass);
        }
      });
    }

    // Display selected model info
    function displaySelectedElementInfo(selectedElement, elementInfoCards) {
      // Display corresponding info card
      elementInfoCards.forEach((card) => {
        if (card.dataset.model != selectedElement.id) {
          card.style.display = "none";
          return;
        }
        card.style.display = "block";

        if (card.dataset.colors) {
          let colors = card.dataset.colors.split("-");
          grassColorOptions.forEach((option) => {
            // Disable all color options
            option.classList.add("disabled");
            // Display only available colors
            if (colors.includes(option.id)) {
              option.classList.remove("disabled");
            }
          });
        }
      });
    }
  }
}
export default Courts